import "../../components/atoms/buttons/button.scss";
import "./variacionDatosPersonal.scss";
import { memo } from "react";
import { useState, useEffect } from "react";
import "./../login/login.scss";
import "@fortawesome/fontawesome-free/scss/fontawesome.scss";
import "@fortawesome/fontawesome-free/scss/solid.scss";
import { useLocation, useNavigate } from "react-router-dom";
import Header from "../../components/molecules/header/Header";
import Footer from "../../components/molecules/footer/Footer";

import AcumuladoresTabActosAdmin from "../../components/molecules/tabs/acumuladoresTab/AcumuladoresTabActosAdmin";
import {
  getDatoBorradores,
  getDatoPresentada,
  validarAlta,
} from "../../components/services/DatoPersonalService";
import { SpinnerCircle } from "../../components/atoms/spinner/Spinner";
import ModalMensajes from "../../components/molecules/modals/modalMensajes/ModalMensajes";

const VariacionDatosPersonal = () => {
  localStorage.setItem("tipoActo","s1")
  const [loading, setLoading] = useState(false);
  const [loadingData, setLoadingData] = useState({
    borradores: false,
    solicitudes: false,
  });
  const navigate = useNavigate();
  const [borradores, setBorradores] = useState([""]);
  const [actosPresentados, setActosPresentados] = useState([]);
  const [errorBorrador, setErrorBorrador] = useState(false);
  const [errorPresentada, setErrorresentada] = useState(false);
  // const { state } = useLocation();
  const location = useLocation();
  
  
  const [accesoPDF] = useState(location.state?.accesoPDF);
  const [show, setShow] = useState({
    mensaje: false
  });

  useEffect(() => {
    setLoading(true);

    getDatoBorradores("s1").then((data) => {
      
      if (data !== undefined) {
        setBorradores(data);
        setLoadingData((prevState) => ({
          ...prevState,
          borradores: true,
        }));
      } else {
        setErrorBorrador(true);
      }
    });
    getDatoPresentada("s1").then((data) => {
      
      if (data !== undefined || !data.toString().startsWith("Error:")) {
        setActosPresentados(data);
        setLoadingData((prevState) => ({
          ...prevState,
          solicitudes: true,
        }));
      } else {
        setErrorresentada(true);
      }
    });
  }, []);

  const handleActualizarPresentada = () => {
    getDatoPresentada("s1").then((data) => {
      
      if (data !== undefined || !data.toString().startsWith("Error:")) {
        setActosPresentados(data);
        setLoadingData((prevState) => ({
          ...prevState,
          solicitudes: true,
        }));
      } else {
        setErrorresentada(true);
      }
    });
  }

  const handleClose = (e) => {
    setShow(false);
  };
  function VariacionDatosPersonal() {
    return (
      <>
        <div className="vh-100">
          <Header></Header>
          <div className="contanier d-flex flex-column align-items-center my-lg-5 my-md-5 my-sm-3 py-2"
            role="main" data-landmark-index="4"
          >
            {loading ? (
              <>
                <div className="container d-flex justify-content-start">
                  {/*<Titulo
                    tipo={"tituloModal "}
                    titulo={"Variación de datos personales"}
                  />*/}
                  <h2 className="tituloAccesibilidadMini">Variación de datos personales</h2>
                </div>
                <p className="mt-2">Acto S1 - Variación de datos personales</p>

                {/* Borradores y Actos presentados */}
                <div className="row d-flex justify-content-center tablaRecNivel">
                  <div className="col-12 card pb-5">
                    {loadingData.borradores && loadingData.solicitudes ? (
                      <AcumuladoresTabActosAdmin
                        borradores={borradores}
                        setBorradores={setBorradores}
                        actosPresentados={actosPresentados}
                        setActosPresentados={setActosPresentados}
                        handleActualizarPresentada={handleActualizarPresentada}
                        loading={loadingData}
                        errorBorrador={errorBorrador}
                        errorPresentada={errorPresentada}
                        accesoPDF={accesoPDF}
                      />
                    ) : (
                      <SpinnerCircle></SpinnerCircle>
                    )}
                  </div>
                </div>
                <div className="d-flex align-items-center row">
                  {/* <ButtonVolver
                    destino={"listadoactos"}
                    clases="col-3 mt-3 mb-3"
                  ></ButtonVolver> */}

                  <div className=" order-1 order-md-0 col-12 col-md-6 d-flex justify-content-center mb-3">
                    <button
                      id="volver"
                      className="btnRed btnSalirDatPersonales rounded btnCancelarDocumentacion"
                      type="button"
                      onClick={() => {

                        navigate("/listadoactos")

                      }}
                    >
                      <i className="fa-solid fa-rotate-left"></i> Volver
                    </button>
                  </div>

                  {borradores.length < 10 ? (
                    //añadir validar alta
                    <div className="order-0 order-md-1 col-12 col-md-6 d-flex justify-content-center">
                      <button
                        id="btnNuevaSolicitudNC"
                        className=" btn btnPresentar rounded  mb-3 fs-5 btnNuevoDatPersonales"
                        tipo="button"
                        onClick={() => {
                          validarAlta(-1, "s1").then((data) => {
                            

                            if (data.estado) {
                              navigate("/borradorActos")
                            } else {
                              setShow({
                                mensaje: true,
                                content: data.descripcion,
                                tipo: "tituloModal",
                                aviso: false,
                                destinoAviso: null,
                                destinoCerrar: null,
                              });
                            }
                          })
                        }}
                      > <i className="fa-solid fa-file-circle-plus"></i> Nuevo
                        Borrador
                      </button>
                    </div>

                  ) : null}
                </div>
              </>
            ) : (
              <></>
            )}
            <br />
          </div>
          <Footer></Footer>
          {show.mensaje ? (
            <>
              {" "}
              <ModalMensajes
                show={show.mensaje}
                handleClose={handleClose}
                content={show.content}
                content2={show.content2}
                tipo={show.tipo}
                aviso={show.aviso}
                destinoAviso={show.destinoAviso}
                destinoCerrar={show.destinoCerrar}
                funcion={show.funcion}
                valorFuncion={show.valorFuncion}
                boton={show.boton}
                contentBold={show.contentBold}
              ></ModalMensajes>
            </>
          ) : null}
        </div>
      </>
    );
  }

  return <>{VariacionDatosPersonal()}</>;
};

export default memo(VariacionDatosPersonal);
